import React, { Fragment, Component, PureComponent } from "react";
import styled, { css } from "styled-components";

import HeadlineSegment from "../../segments/HeadlineSegment";
import GallerySegment from "../../segments/GallerySegment";
import ContactSegment from "../../segments/ContactSegment";
import TeamSegment from "../../segments/TeamSegment";

const LocalitySelector = styled.section`
  position: relative;
  width: 100%;
  padding-top: 7.5em;
  margin-bottom: 15em;
  box-sizing: border-box;
  height: 17.5em;

  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    transform: scale(0.65) skewY(3deg);
    transform-origin: left;
    background: linear-gradient(
      90deg,
      rgba(63, 0, 255, 0.25),
      rgba(63, 0, 255, 0.5)
    );
    z-index: -1;
  }

  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    transform: scale(0.65) skewY(3deg);
    transform-origin: right;
    background: linear-gradient(
      90deg,
      rgba(0, 39, 180, 0.5),
      rgba(0, 39, 180, 0.25)
    );
    z-index: -2;
  }

  @media (max-width: 350px) {
    height: 15em;
  }
`;

const Localities = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  &:before {
    content: "";
    position: absolute;
    transform: skewY(6deg);
    background: linear-gradient(45deg, rgb(125, 53, 255), rgb(42, 98, 255) 75%);
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  &:after {
    content: "";
    position: absolute;
    transform: skewY(6deg);
    background: linear-gradient(45deg, rgb(125, 53, 255) 75%, rgb(42, 98, 255));
    width: 100%;
    height: 100%;
    z-index: -1;

    opacity: ${props => (props.weight === "left" ? 1 : 0)};
    transition: opacity 0.5s ease-in;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 0.75em;

  @media (max-width: 350px) {
    display: grid;
    grid-auto-flow: column;
  }
`;

const Locality = styled.div`
  background: white;
  border-radius: 1em;
  padding: 2em;
  margin: 2em;
  font-size: 1.5em;
  font-family: Raleway, sans-serif;
  font-weight: 500;
  transition: all 0.5s;
  text-align: end;
  &:before {
    content: "Unsere Praxis in";
    font-family: Raleway, sans-serif;
    font-weight: 400;
    font-size: 0.75em;
    display: block;
    text-align: end;
    color: black;
  }

  &:hover {
    transform: translate(-0.5em, 0.75em);
    box-shadow: 0px 5px 20px 0px rgba(255, 255, 255, 0.44);
    cursor: pointer;
  }

  @media (max-width: 450px) {
    margin: 0.5em;
  }

  @media (max-width: 350px) {
    padding: 1.5em;
  }

  ${props =>
    props.selected
      ? css`
          transform: translate(-0.5em, 0.75em);
          box-shadow: 0px 5px 20px 0px rgba(255, 255, 255, 0.44);
          cursor: pointer;
          color: ${props => props.selectionColor};
        `
      : ``};
`;

class LocalSection extends PureComponent {
  state = {
    locality: 1
  };

  render() {
    return (
      <Fragment>
        <GallerySegment cms={this.props.cms} locality={this.state.locality} />
        <HeadlineSegment children={this.props.cms["local-section-title"]} />
        <LocalitySelector>
          <Localities weight={this.state.locality === 0 ? "left" : "right"}>
            <Locality
              onClick={() => this.setState({ locality: 0 })}
              selected={this.state.locality === 0}
              selectionColor="rgba(63, 0, 255, 0.5)"
              children={this.props.cms["secondary-locality"].label}
            />
            <Locality
              onClick={() => this.setState({ locality: 1 })}
              selected={this.state.locality === 1}
              selectionColor="rgba(0, 39, 180, 0.5)"
              children={this.props.cms["primary-locality"].label}
            />
          </Localities>
        </LocalitySelector>
        <TeamSegment cms={this.props.cms} locality={this.state.locality} />
        <ContactSegment cms={this.props.cms} locality={this.state.locality} />
      </Fragment>
    );
  }
}

export default LocalSection;



// WEBPACK FOOTER //
// /opt/build/repo/src/pages/Landing/LocalSection.js